import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { getSegmentModificationType } from "../../redux/actions/pollingAction";
import { toTitleCase } from "../../helpers/TitleCase";
import charticon from "../../assets/icons/Path 23145.svg";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PredictionStepper from "../../pages/prediction/predictionStepper";

const ModifySelectionComp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const predictionType = searchParams.get("select");
  const pollsterCategory = searchParams.get("pollster");

  // console.log("predictionType ", predictionType, pollsterCategory);

  useEffect(() => {
    dispatch(getSegmentModificationType());
    if (prediction?.selectCountry === null) {
      navigate("/prediction");
    }
  }, []);

  const predictionbuttonArray = [
    { label: "New Prediction", path: "" },
    // { label: "Completed Predictions", path: "" },
    { label: "My Live Predictions", path: "/prediction" },
    { label: "Followed Predictions", path: "/prediction/followed_prediction" },
    // { label: "Followed Profiles", path: "" },
  ];

  const handleNavigate = (path, label) => {
    if (path) {
      if (label === "Followed Predictions") {
        navigate(path);
      } else {
        window.location.reload();
      }
    }
  };

  const { prediction } = useContext(PredictionContext);
  const { SegemntModificationTypeResponse } = useSelector(
    (state) => state?.pollWeb
  );

  const handleModification = (slug) => {
    navigate(
      `/prediction/new/${params?.id}?select=${predictionType}&pollster=${pollsterCategory}&modify=${slug}`
    );
  };

  return (
    <div className="bg_home flex flex-col pb-8 h-auto">
      <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5 h-auto">
        <div className="bg-white w-full rounded-xl shadow-sm md:p-5">
          <div>
            <div className="px-1">
              <div className="my-2 text-[12px] text-[#7F8FA4] hidden sm:flex">
                {prediction?.selectCountry?.name && (
                  <div className="">{prediction?.selectCountry?.name}</div>
                )}
                {prediction?.electionTypeData?.type &&
                  prediction?.predictionTitle && (
                    <div className="mx-1">
                      {`> ${
                        prediction?.electionTypeData?.type
                      }  > ${toTitleCase(prediction?.predictionTitle).replace(
                        "_",
                        " "
                      )}`}{" "}
                    </div>
                  )}
              </div>
            </div>
            <PredictionStepper />
            <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 justify-start gap-1 md:gap-4 items-center p-3">
              {predictionbuttonArray?.map((label, index) => {
                return (
                  <div
                    key={index}
                    className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${
                      label?.label === "New Prediction" &&
                      "bg-[#4252A8] text-white"
                    }`}
                    onClick={() => handleNavigate(label?.path, label?.label)}
                  >
                    <img src={charticon} alt="chart-icon" width={12} />
                    {label?.label}
                  </div>
                );
              })}
            </div>
            <div className="font-semibold">
              <p>Modify your selection</p>
            </div>
            <div className="flex flex-col gap-5 py-2 my-2 overflow-y-auto max-h-[calc(100vh-80px)] md:max-h-[calc(100vh-100px)]">
              <div className="">
                <div className="my-2 grid grid-cols-1 min-[380px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2">
                  {SegemntModificationTypeResponse?.map((res, index) => {
                    return (
                      <div
                        key={res?.id}
                        className="m-auto  min-[380px]:m-0 size-[160px] hover:bg-white bg-[#F7F8FA] hover:border-2 border-red-500 cursor-pointer rounded-xl flex justify-center items-center flex-col"
                        onClick={() => handleModification(res?.slug)}
                      >
                        <img src={res?.icon} alt="indian-flag" width={80} />
                        <p className="mt-5 text-[12px] font-semibold text-center">
                          {res?.displayName}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModifySelectionComp;
